import React from 'react';
import Notification from 'syngenta-digital-cropwise-react-ui-kit/dist/components/notification';

/**
 * Warns that the invoice saved but the list price update did not.
 *
 * Deliberately separate from `invoiceNotification`: that reports "Unable to
 * save Invoice", which would be untrue here and far more alarming than what
 * actually happened. Deliberately a warning rather than an error, for the same
 * reason — nothing the user entered has been lost.
 */
const listPriceNotification = () => {
  Notification.warning({
    // @ts-ignore — the kit types `message` as string, but every caller in this
    // repo passes a node for the bolded title.
    message: <span className="font-semibold">Invoice saved.</span>,
    description:
      'The list price could not be updated for one or more products. The invoice itself was saved — you can update the list price from the product later.',
    placement: 'topRight',
    duration: 8
  });
};

export default listPriceNotification;
